import React from "react";

const Login = () => {
  return (
    <div>
      <h1>Login Form</h1>
    </div>
  );
};

export default Login;

<h1>Login Form</h1>;
